import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import SegmentButton from 'ui-component/Segment/SegmentButton';
import { useTheme } from '@mui/material/styles';
import { useNewVersion } from 'contexts/NewVersionContext';
import { gridSpacing } from 'constants/themeConstants';

export const NewVersionBanner = () => {
  const theme = useTheme();
  const { handleUpdateVersion } = useNewVersion();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.success.main,
        padding: '2px',
        color: '#FFF',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={gridSpacing}
      >
        <Typography variant="body1" color="inherit" noWrap>
          A new Version of Cofactr is ready. Please refresh to get the latest
          updates!
        </Typography>
        <SegmentButton
          size="small"
          onClick={handleUpdateVersion}
          sx={{
            color: 'background.paper',
            fontSize: '12px',
            margin: 'auto',
          }}
        >
          Refresh
        </SegmentButton>
      </Stack>
    </Box>
  );
};
